<ion-fab vertical="bottom" horizontal="end" slot="fixed">
  <ion-fab-button (click)="onAdd()">
    <ion-icon class="zoom" name="add"></ion-icon>
  </ion-fab-button>
</ion-fab>
